export const FETCH_SHOP_LIST = "FETCH_SHOP_LIST";
export const FETCH_NEWESTSHOP_LIST = "FETCH_NEWESTSHOP_LIST";
export const RESET_SHOP_FILTER_LIST = "RESET_SHOP_FILTER_LIST";
export const FETCH_SHOP_FILTER_LIST = "FETCH_SHOP_FILTER_LIST";
export const FETCH_FILTER_PBM_LIST = "FETCH_FILTER_PBM_LIST";
export const FETCH_FILTER_RPG_LIST = "FETCH_FILTER_RPG_LIST";
export const FETCH_MODEL_SERVICES = "FETCH_MODEL_SERVICES";
export const SET_FIND_LOCATION = "SET_FIND_LOCATION";
export const SET_MODEL_SERVICE = "SET_MODEL_SERVICE";
export const SET_LOAD_SERVICE = "SET_LOAD_SERVICE";
export const SET_LOAD_PBM_LIST = "SET_LOAD_PBM_LIST";
export const SET_SEARCH_FILTER = "SET_SEARCH_FILTER";
export const IS_FIND_OUT = "IS_FIND_OUT";
export const SET_LOAD_FILTER = "SET_LOAD_FILTER";
export const GET_SHOP_DEVICES = "GET_SHOP_DEVICES";
export const SET_DEVICES = "SET_DEVICES";
export const SET_DEVICE_BRANDS = "SET_DEVICE_BRANDS";
export const SET_BRAND_MODELS = "SET_BRAND_MODELS";
export const GET_DEVICE_BRANDS = "GET_DEVICE_BRANDS";
export const GET_BRAND_MODELS = "GET_BRAND_MODELS";
export const SET_REPARATIES = "SET_REPARATIES";
export const GET_REPARATION_DETAILS = "GET_REPARATION_DETAILS";
export const UPDATE_REPARATION_LOADING = "UPDATE_REPARATION_LOADING";
export const SAVE_REPARATION_LOADING = "SAVE_REPARATION_LOADING";
export const GET_PAGES = "GET_PAGES";
export const GET_PAGE_DETAILS = "GET_PAGE_DETAILS";

export default {
  FETCH_SHOP_LIST,
  RESET_SHOP_FILTER_LIST,
  FETCH_FILTER_PBM_LIST,
  FETCH_FILTER_RPG_LIST,
  IS_FIND_OUT,
};
